<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import { Head } from '@inertiajs/vue3';
</script>

<script>
export default {
    data() {
        return {
            // test: 'XXX',
            // wtf: false
        }
    },

    methods: {
        // ...
    },

    // Component is mounted
    mounted() {

        // Page view DataLayer event
        if (dataLayer) {
            dataLayer.push({
                event: 'virtualPageView',
                page_type: 'about',
                site_language: this.$page.props.locale?.toUpperCase() || '?',
                login_status: this.$page.props.user ? 'logged_in' : 'logged_out',
                user_id: this.$page.props.user ? this.$page.props.user.id : null,
            });
        }

    }
}
</script>

<template>

    <Head :title="$t('Transzferről')" />

    <AppLayout>

        <header class="header">
            <div class="header-body header-body-subpage">
                <div class="container-fluid">
                    <div class="row align-items-center justify-content-center">
                        <div class="col-12 col-sm-auto col-lg text-center text-sm-right text-lg-left">
                            <h1 class="header-h1">{{ $t('A transzferről') }}</h1>
                        </div>
                    </div>
                </div>
            </div>
        </header>

        <div class="header-placeholder"></div>

        <div class="subpage-content">
            <div class="container subpage-container">
                <div class="row">
                    <main class="main col-12">
                        <section>
                            <div class="row section-title d-none">
                                <div class="col-12">
                                    <h2>{{ $t('A transzferről') }}</h2>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="mb-3 text-center">
                                        <iframe style="max-width:100%;" width="560" height="315" src="https://www.youtube.com/embed/lI1WEYlbGR8" :title="$t('miniBUD Airport Shuttle')" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                                    </div>
                                    <div>
                                        <h2 class="h4">{{ $t('A cég') }}</h2>
                                        <p v-html="$t('A miniBUD a Liszt Ferenc Nemzetközi Repülőtér hivatalos airport shuttle szolgáltatója. Kényelmes, gyors és kedvező transzfermegoldásokat nyújtunk azon ügyfeleink részére, akik a repülőtérről Budapest frekventált kerületeibe vagy ezekből a repülőtérre szeretnének eljutni.')">
                                        </p>
                                        <h3 class="h4">{{ $t('Szolgáltatások') }}</h3>
                                        <ul>
                                            <li>{{ $t('miniBUD reptéri transzfer') }}</li>
                                            <li>{{ $t('BUDAPEST CARD - Hivatalos város kártya') }}</li>
                                            <li>{{ $t('HOP ON HOP OFF – The best Budapest sightseeing tours') }}</li>
                                            <li>{{ $t('FAST TRACK - Fast track lane service, passenger security screening without queuing') }}</li>
                                            <li>{{ $t('Egyéb szolgáltatások') }}</li>
                                        </ul>
                                    </div>
                                    <div>
                                        <h3 class="h4">{{ $t('Elérhetőségek') }}</h3>
                                        <div class="row">
                                            <div class="col-12 col-md-6">
                                                <p v-html="$t('Székhely: 1185 Budapest BUD Nemzetközi repülőtér T1 Terminál, E215. <br><br>Ügyfélszolgálat és értékesítési pontok: Budapest Liszt Ferenc Nemzetközi Repülőtér 2A és 2B Terminál érkezési szint')">
                                                </p><br>
                                                <p>{{ $t('E-mail cím') }}: <a href="mailto:info@minibud.hu">info@minibud.hu</a><br>{{ $t('Honlap') }}: <a href="https://minibud.hu">minibud.hu</a></p><br>
                                                <p>{{ $t('miniBUD telefonos ügyfélszolgálat') }}: <a href="tel:+3615500000">+36 1 550 0000</a></p>
                                            </div>
                                            <div class="col-12 col-md-6">
                                                <p>{{ $t('Adószám') }}: <br>25436864-2-43</p>
                                                <p>{{ $t('Cégjegyzékszám') }}: <br>01-09-275125</p>
                                                <p>MKB (Magyar Kereskedelmi Bank):<br>{{ $t('HUF számla IBAN') }}: HU 34 10300002-10654029-49020013<br>{{ $t('EUR számla IBAN') }}: HU
                                                    60 10300002-10654029-48820016<br>{{ $t('SWIFT CODE') }}: MKKBHUHB</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </main>
                </div>
            </div>
        </div>

    </AppLayout>
</template>
